import { render } from "./SecureSpmButton.vue?vue&type=template&id=5beb8916&scoped=true"
import script from "./SecureSpmButton.vue?vue&type=script&lang=ts"
export * from "./SecureSpmButton.vue?vue&type=script&lang=ts"

import "./SecureSpmButton.vue?vue&type=style&index=0&id=5beb8916&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5beb8916"

export default script